import { combineReducers } from "redux";

import section from "../features/admin/sections/section/Slice";

import common from "../features/admin/common/Slice";

const services = combineReducers({
  section,
  common,
});

export default services;
